import React from 'react'
import './index.css'

function Loading() {
  return (
    <div>
        <span className="loader"></span>
    </div>
  )
}

export default Loading